import { Tag } from "./Tag";
import { OfferCreative } from "./OfferCreative";
import { Goal } from "./Goal";
import { Promotion } from "./Promotion";
import { OfferCurrencySale } from "./OfferCurrencySale";

export interface Offer {
  id: number;
  title: string;
  previewUrl: string | null;
  rewardIac: number;
  popularityScore: number;
  thumbnailUrl: string;
  heroImageUrl?: string;
  earningsPerClick: number;
  description: string[];
  instructions?: string[];
  platforms: string[];
  operatingSystems: string[];
  tags: Tag[];
  offerCreatives: OfferCreative[];
  createdAt: Date | string | null;
  attemptedAt: string;
  attributionWindowMinutes?: number | null;
  totalStandardGoalRewardIac?: number;
  standardGoals?: Goal[];
  totalPurchaseGoalRewardIac?: number;
  purchaseGoals?: Goal[];
  promotion?: Promotion;
  campaignCurrencySale?: OfferCurrencySale;
  isCompleted?: boolean;
  status: OfferStatuses;
  isFeatured: boolean;
  featuredRank?: number | null;
  bannerAd?: {
    header: string;
    buttonText: string;
    description: string;
  } | null;
}

export enum OfferStatuses {
  Open = "Open",
  Closed = "Closed",
}
